import Vue from 'vue';
import Vuex from 'vuex';
import { Storage } from '../utils/storage'

Vue.use(Vuex);

export default new Vuex.Store({
    namespaced: true,
    state: {
        userInfo: {},
        lang: '',
    },
    getters: {
        getUserInfo(state) {
            return state.userInfo;
        },
        getLang(state) {
            return state.lang
        }
    },
    mutations: {
        setUserInfo(state, info) {
            state.userInfo = info;
            if (Object.keys(info).length > 0) {
                Storage.setItem('user', JSON.stringify(info));
                if (info?.token) {
                    Storage.setItem('token', info.token);
                }
            } else {
                Storage.removeItem('user');
                Storage.removeItem('token');
            }
        },
        setLang(state, lang) {
            state.lang = lang;
            Storage.setItem('lang', lang)
        }
    }
});
